<template>
  <div class="categories" >
    <router-link to="/info/mlodosc" :class="{ animated: isAnimated }" class="categories_block" @click.native="offCategories('/info/mlodosc')">
      <span>Młodość</span>
    </router-link>
    <router-link to="/info/stocznia" :class="{ animated: isAnimated }" class="categories_block" @click.native="offCategories">
      <span>Stocznia</span>
    </router-link>
    <router-link to="/info/solidarnosc" :class="{ animated: isAnimated }" class="categories_block" @click.native="offCategories">
      <span>Solidarność</span>
    </router-link>
    <router-link to="/info/samaprzeciwszystkim" :class="{ animated: isAnimated }" class="categories_block" @click.native="offCategories">
      <span>Sama przeciw wszystkim</span>
    </router-link>
    <router-link to="/info/wzapomnieniu" :class="{ animated: isAnimated }" class="categories_block" @click.native="offCategories">
      <span>W zapomnieniu</span>
    </router-link>
    <router-link to="/info/tragicznylot" :class="{ animated: isAnimated }" class="categories_block" @click.native="offCategories">
      <span>Tragiczny lot</span>
    </router-link>
  </div>
</template>

<script>

export default {
  name: "Categories",
  data() {
    return {
      isAnimated: true
    };
  },
  mounted: function() {
    setTimeout(() => {
      this.isAnimated = false;
    }, 2100);
  },
  methods: {
    offCategories(site){
      this.$emit("clicked")
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes start {
  0% {
    height: 0 ;
  }
  100% {
    height: 100vh;
    color: #3e3c40;
  }
}

.animated {
  pointer-events: none;
  color: transparent !important;
  &:nth-child(1) {
    animation: start 0.6s forwards;
  }
  &:nth-child(2) {
    height: 0;
    animation: start 0.6s forwards;
    animation-delay: 0.3s;
  }
  &:nth-child(3) {
    height: 0;
    animation: start 0.6s forwards;
    animation-delay: 0.6s;
  }
  &:nth-child(4) {
    height: 0;
    animation: start 0.6s forwards;
    animation-delay: 0.9s;
  }
  &:nth-child(5) {
    height: 0;
    animation: start 0.6s forwards;
    animation-delay: 1.2s;
  }
  &:nth-child(6) {
    height: 0;
    animation: start 0.6s forwards;
    animation-delay: 1.5s;
  }
}

.categories {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100vh;

  &_block {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Oswald", sans-serif;
    font-size: 1.5rem;
    font-weight: bold;
    text-transform: uppercase;
    text-align: center;
    color: #3e3c40;
    border-right: 1px solid #85837d;
    position: relative;
    cursor: pointer;
    background-size: 100% !important;

    span {
      position: absolute;
      z-index: 2;
    }

    @keyframes slide {
      0% {
        top: 0%;
      }
      100% {
        top: 100%;
      }
    }

    @keyframes color {
      0% {
        color: #3e3c40;
      }
      100% {
        color: #f05a42;
      }
    }

    &::after {
      content: "";
      position: absolute;
      width: 100%;
      background: rgba(255, 255, 255, 0.7);
      height: 100%;
    }

    &:hover {
      color: #f05a42;
      &::after {
        animation: slide 1s forwards;
        top: 100%;
      }
      animation: color 1s;
    }

    &:nth-child(1) {
      background: url("./partials/mlodosc.png");
    }
    &:nth-child(2) {
      background: url("./partials/stocznia.png");
    }
    &:nth-child(3) {
      background: url("./partials/solidarnosc.png");
    }
    &:nth-child(4) {
      background: url("./partials/przeciw.png");
    }
    &:nth-child(5) {
      background: url("./partials/zapomnienie.png");
    }
    &:nth-child(6) {
      background: url("./partials/lot.png");
    }
  }
}
</style>
